import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { firestoreConnect } from 'react-redux-firebase'
import { Redirect } from 'react-router-dom'
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import { Link } from 'react-router-dom'
import FormSummary from './formSummary'

class Forms extends Component {

  render() {
    const { forms, auth } = this.props

    if (!auth.uid) return <Redirect to='/signin' />

    return (
      <div style={{ width: '80%', margin: 'auto', maxWidth: 500 }}>
        <Link to={'/create-form'}>
          <Button
            style={{ float: 'right', margin: '10px 20px -10px 0' }}
            variant="contained"
            color="primary"
            startIcon={<AddIcon />}
          >Add New Form </Button></Link>
        <div style={{ clear: 'both', height: 1, width: '100%' }}></div>
        {
          forms && forms.length ? forms.map((form) => {
            return (
              <FormSummary key={form.id} {...form} />
            )
          })
            : null
        }
      </div>
    )
  }
}

const mapStateToProps = (state) => {

  return {
    forms: state.firestore.ordered.forms,
    auth: state.firebase.auth
  }
}

export default compose(
  connect(mapStateToProps),
  firestoreConnect([
    { collection: 'forms', orderBy: ['createdAt', 'desc'] },
  ])
)(Forms)
